// AeroZeep Mock Data & Constants

import type {
  Airline,
  Bank,
  City,
  Flight,
  Ticket,
  RefundRequest,
  WalletTransaction,
  Invoice,
  FraudAlert,
  AuditLog,
  ComplianceViolation,
} from '../types'

// Nigerian Banks
export const NIGERIAN_BANKS: Bank[] = [
  { code: '044', name: 'Access Bank' },
  { code: '023', name: 'Citibank Nigeria' },
  { code: '050', name: 'Ecobank Nigeria' },
  { code: '070', name: 'Fidelity Bank' },
  { code: '011', name: 'First Bank of Nigeria' },
  { code: '214', name: 'First City Monument Bank' },
  { code: '058', name: 'Guaranty Trust Bank' },
  { code: '030', name: 'Heritage Bank' },
  { code: '301', name: 'Jaiz Bank' },
  { code: '082', name: 'Keystone Bank' },
  { code: '526', name: 'Parallex Bank' },
  { code: '076', name: 'Polaris Bank' },
  { code: '101', name: 'Providus Bank' },
  { code: '221', name: 'Stanbic IBTC Bank' },
  { code: '068', name: 'Standard Chartered Bank' },
  { code: '232', name: 'Sterling Bank' },
  { code: '100', name: 'Suntrust Bank' },
  { code: '032', name: 'Union Bank of Nigeria' },
  { code: '033', name: 'United Bank for Africa' },
  { code: '215', name: 'Unity Bank' },
  { code: '035', name: 'Wema Bank' },
  { code: '057', name: 'Zenith Bank' },
  { code: '999', name: 'Kuda Bank' },
  { code: '998', name: 'Opay' },
  { code: '997', name: 'PalmPay' },
]

// Nigerian Cities with Airports
export const NIGERIAN_CITIES: City[] = [
  { code: 'LOS', name: 'Lagos', state: 'Lagos' },
  { code: 'ABV', name: 'Abuja', state: 'FCT' },
  { code: 'PHC', name: 'Port Harcourt', state: 'Rivers' },
  { code: 'KAN', name: 'Kano', state: 'Kano' },
  { code: 'ENU', name: 'Enugu', state: 'Enugu' },
  { code: 'BNI', name: 'Benin City', state: 'Edo' },
  { code: 'CBQ', name: 'Calabar', state: 'Cross River' },
  { code: 'ILR', name: 'Ilorin', state: 'Kwara' },
  { code: 'JOS', name: 'Jos', state: 'Plateau' },
  { code: 'KAD', name: 'Kaduna', state: 'Kaduna' },
  { code: 'MIU', name: 'Maiduguri', state: 'Borno' },
  { code: 'QOW', name: 'Owerri', state: 'Imo' },
  { code: 'SKO', name: 'Sokoto', state: 'Sokoto' },
  { code: 'YOL', name: 'Yola', state: 'Adamawa' },
  { code: 'ABB', name: 'Asaba', state: 'Delta' },
  { code: 'AKR', name: 'Akure', state: 'Ondo' },
  { code: 'QUO', name: 'Uyo', state: 'Akwa Ibom' },
  { code: 'WRI', name: 'Warri', state: 'Delta' },
]

// Nigerian Airlines
export const NIGERIAN_AIRLINES: Airline[] = [
  {
    id: 'air-peace',
    name: 'Air Peace',
    code: 'P4',
    logo: 'https://upload.wikimedia.org/wikipedia/en/thumb/3/3d/Air_Peace_logo.svg/200px-Air_Peace_logo.svg.png',
    complianceScore: 92,
    avgRefundTime: 25,
    totalRefunds: 4523,
    amountOwed: 12500000,
    noShowCount: 150,
    refundsProcessedCount: 4523,
    totalRefundValue: 250000000,
    amountPaidBack: 237500000,
  },
  {
    id: 'arik-air',
    name: 'Arik Air',
    code: 'W3',
    logo: 'https://upload.wikimedia.org/wikipedia/en/thumb/9/9f/Arik_Air_logo.svg/200px-Arik_Air_logo.svg.png',
    complianceScore: 78,
    avgRefundTime: 45,
    totalRefunds: 2891,
    amountOwed: 8750000,
    noShowCount: 210,
    refundsProcessedCount: 2891,
    totalRefundValue: 180000000,
    amountPaidBack: 171250000,
  },
  {
    id: 'dana-air',
    name: 'Dana Air',
    code: '9J',
    logo: 'https://upload.wikimedia.org/wikipedia/en/thumb/8/8c/Dana_Air_logo.svg/200px-Dana_Air_logo.svg.png',
    complianceScore: 85,
    avgRefundTime: 32,
    totalRefunds: 1876,
    amountOwed: 5200000,
    noShowCount: 95,
    refundsProcessedCount: 1876,
    totalRefundValue: 120000000,
    amountPaidBack: 114800000,
  },
  {
    id: 'aero-contractors',
    name: 'Aero Contractors',
    code: 'N2',
    logo: 'https://upload.wikimedia.org/wikipedia/en/thumb/5/5f/Aero_Contractors_logo.svg/200px-Aero_Contractors_logo.svg.png',
    complianceScore: 88,
    avgRefundTime: 28,
    totalRefunds: 1234,
    amountOwed: 3450000,
    noShowCount: 80,
    refundsProcessedCount: 1234,
    totalRefundValue: 85000000,
    amountPaidBack: 81550000,
  },
  {
    id: 'ibom-air',
    name: 'Ibom Air',
    code: 'QI',
    logo: 'https://upload.wikimedia.org/wikipedia/en/thumb/c/c5/Ibom_Air_logo.svg/200px-Ibom_Air_logo.svg.png',
    complianceScore: 95,
    avgRefundTime: 18,
    totalRefunds: 987,
    amountOwed: 0,
    noShowCount: 45,
    refundsProcessedCount: 987,
    totalRefundValue: 65000000,
    amountPaidBack: 65000000,
  },
]

// Mock Flights
export const MOCK_FLIGHTS: Flight[] = [
  {
    id: 'flight-1',
    airline: NIGERIAN_AIRLINES[0],
    flightNumber: 'P4-7201',
    origin: 'LOS',
    originCity: 'Lagos',
    destination: 'ABV',
    destinationCity: 'Abuja',
    departureTime: '2024-02-15T08:00:00',
    arrivalTime: '2024-02-15T09:15:00',
    duration: 75,
    price: 45000,
    class: 'economy',
  },
  {
    id: 'flight-2',
    airline: NIGERIAN_AIRLINES[0],
    flightNumber: 'P4-7203',
    origin: 'LOS',
    originCity: 'Lagos',
    destination: 'ABV',
    destinationCity: 'Abuja',
    departureTime: '2024-02-15T14:30:00',
    arrivalTime: '2024-02-15T15:45:00',
    duration: 75,
    price: 52000,
    class: 'economy',
  },
  {
    id: 'flight-3',
    airline: NIGERIAN_AIRLINES[1],
    flightNumber: 'W3-501',
    origin: 'LOS',
    originCity: 'Lagos',
    destination: 'PHC',
    destinationCity: 'Port Harcourt',
    departureTime: '2024-02-15T10:00:00',
    arrivalTime: '2024-02-15T11:10:00',
    duration: 70,
    price: 38000,
    class: 'economy',
  },
  {
    id: 'flight-4',
    airline: NIGERIAN_AIRLINES[4],
    flightNumber: 'QI-1102',
    origin: 'ABV',
    originCity: 'Abuja',
    destination: 'QUO',
    destinationCity: 'Uyo',
    departureTime: '2024-02-15T16:00:00',
    arrivalTime: '2024-02-15T17:30:00',
    duration: 90,
    price: 48000,
    class: 'economy',
  },
  {
    id: 'flight-5',
    airline: NIGERIAN_AIRLINES[2],
    flightNumber: '9J-302',
    origin: 'ABV',
    originCity: 'Abuja',
    destination: 'KAN',
    destinationCity: 'Kano',
    departureTime: '2024-02-16T09:30:00',
    arrivalTime: '2024-02-16T10:45:00',
    duration: 75,
    price: 42000,
    class: 'economy',
  },
  {
    id: 'flight-6',
    airline: NIGERIAN_AIRLINES[3],
    flightNumber: 'N2-104',
    origin: 'PHC',
    originCity: 'Port Harcourt',
    destination: 'LOS',
    destinationCity: 'Lagos',
    departureTime: '2024-02-16T12:00:00',
    arrivalTime: '2024-02-16T13:10:00',
    duration: 70,
    price: 39000,
    class: 'economy',
  },
]

// Demo PNR and Ticket Numbers for testing
export const DEMO_TICKETS = [
  {
    pnr: 'ABC123',
    ticket: '0842401234567',
    description: 'Lagos → Abuja (Air Peace)',
  },
  {
    pnr: 'DEF456',
    ticket: '0842401234568',
    description: 'Lagos → Port Harcourt (Arik Air)',
  },
  {
    pnr: 'GHI789',
    ticket: '0842401234569',
    description: 'Abuja → Uyo (Ibom Air)',
  },
  {
    pnr: 'JKL012',
    ticket: '0842401234570',
    description: 'Abuja → Kano (Dana Air)',
  },
  {
    pnr: 'MNO345',
    ticket: '0842401234571',
    description: 'Port Harcourt → Lagos (Aero Contractors)',
  },
]

// Mock Tickets - Map of all demo tickets
export const MOCK_TICKETS: Record<string, Ticket> = {
  ABC123: {
    id: 'ticket-001',
    pnr: 'ABC123',
    ticketNumber: '0842401234567',
    passenger: {
      firstName: 'Chioma',
      lastName: 'Okonkwo',
      email: 'chioma.okonkwo@email.com',
      phone: '+2348012345678',
    },
    flight: MOCK_FLIGHTS[0],
    purchaseDate: '2024-02-01T10:30:00',
    status: 'cancelled',
    originalAmount: 45000,
  },
  '0842401234567': {
    id: 'ticket-001',
    pnr: 'ABC123',
    ticketNumber: '0842401234567',
    passenger: {
      firstName: 'Chioma',
      lastName: 'Okonkwo',
      email: 'chioma.okonkwo@email.com',
      phone: '+2348012345678',
    },
    flight: MOCK_FLIGHTS[0],
    purchaseDate: '2024-02-01T10:30:00',
    status: 'cancelled',
    originalAmount: 45000,
  },
  DEF456: {
    id: 'ticket-002',
    pnr: 'DEF456',
    ticketNumber: '0842401234568',
    passenger: {
      firstName: 'Emeka',
      lastName: 'Eze',
      email: 'emeka.eze@email.com',
      phone: '+2348023456789',
    },
    flight: MOCK_FLIGHTS[2],
    purchaseDate: '2024-02-02T14:20:00',
    status: 'cancelled',
    originalAmount: 38000,
  },
  '0842401234568': {
    id: 'ticket-002',
    pnr: 'DEF456',
    ticketNumber: '0842401234568',
    passenger: {
      firstName: 'Emeka',
      lastName: 'Eze',
      email: 'emeka.eze@email.com',
      phone: '+2348023456789',
    },
    flight: MOCK_FLIGHTS[2],
    purchaseDate: '2024-02-02T14:20:00',
    status: 'cancelled',
    originalAmount: 38000,
  },
  GHI789: {
    id: 'ticket-003',
    pnr: 'GHI789',
    ticketNumber: '0842401234569',
    passenger: {
      firstName: 'Ngozi',
      lastName: 'Nwosu',
      email: 'ngozi.nwosu@email.com',
      phone: '+2348034567890',
    },
    flight: MOCK_FLIGHTS[3],
    purchaseDate: '2024-02-03T09:15:00',
    status: 'cancelled',
    originalAmount: 48000,
  },
  '0842401234569': {
    id: 'ticket-003',
    pnr: 'GHI789',
    ticketNumber: '0842401234569',
    passenger: {
      firstName: 'Ngozi',
      lastName: 'Nwosu',
      email: 'ngozi.nwosu@email.com',
      phone: '+2348034567890',
    },
    flight: MOCK_FLIGHTS[3],
    purchaseDate: '2024-02-03T09:15:00',
    status: 'cancelled',
    originalAmount: 48000,
  },
  JKL012: {
    id: 'ticket-004',
    pnr: 'JKL012',
    ticketNumber: '0842401234570',
    passenger: {
      firstName: 'Adebayo',
      lastName: 'Ogundimu',
      email: 'adebayo.ogundimu@email.com',
      phone: '+2348045678901',
    },
    flight: MOCK_FLIGHTS[4],
    purchaseDate: '2024-02-04T11:45:00',
    status: 'cancelled',
    originalAmount: 42000,
  },
  '0842401234570': {
    id: 'ticket-004',
    pnr: 'JKL012',
    ticketNumber: '0842401234570',
    passenger: {
      firstName: 'Adebayo',
      lastName: 'Ogundimu',
      email: 'adebayo.ogundimu@email.com',
      phone: '+2348045678901',
    },
    flight: MOCK_FLIGHTS[4],
    purchaseDate: '2024-02-04T11:45:00',
    status: 'cancelled',
    originalAmount: 42000,
  },
  MNO345: {
    id: 'ticket-005',
    pnr: 'MNO345',
    ticketNumber: '0842401234571',
    passenger: {
      firstName: 'Fatima',
      lastName: 'Mohammed',
      email: 'fatima.mohammed@email.com',
      phone: '+2348056789012',
    },
    flight: MOCK_FLIGHTS[5],
    purchaseDate: '2024-02-05T16:30:00',
    status: 'cancelled',
    originalAmount: 39000,
  },
  '0842401234571': {
    id: 'ticket-005',
    pnr: 'MNO345',
    ticketNumber: '0842401234571',
    passenger: {
      firstName: 'Fatima',
      lastName: 'Mohammed',
      email: 'fatima.mohammed@email.com',
      phone: '+2348056789012',
    },
    flight: MOCK_FLIGHTS[5],
    purchaseDate: '2024-02-05T16:30:00',
    status: 'cancelled',
    originalAmount: 39000,
  },
}

// Legacy export for backward compatibility
export const MOCK_TICKET: Ticket = MOCK_TICKETS['ABC123']

// Mock Wallet Transactions
export const MOCK_WALLET_TRANSACTIONS: WalletTransaction[] = [
  {
    id: 'txn-001',
    type: 'credit',
    amount: 48000,
    description: 'Refund - Air Peace P4-7201',
    reference: 'REF-2024-001',
    status: 'completed',
    createdAt: '2024-02-10T14:30:00',
    metadata: {
      refundId: 'refund-001',
      flightNumber: 'P4-7201',
    },
  },
  {
    id: 'txn-002',
    type: 'debit',
    amount: 38000,
    description: 'Booking - Arik Air W3-501',
    reference: 'BKG-2024-001',
    status: 'completed',
    createdAt: '2024-02-12T09:15:00',
    metadata: {
      bookingId: 'booking-001',
      flightNumber: 'W3-501',
    },
  },
  {
    id: 'txn-003',
    type: 'credit',
    amount: 55000,
    description: 'Refund - Dana Air 9J-302',
    reference: 'REF-2024-002',
    status: 'completed',
    createdAt: '2024-02-14T11:45:00',
    metadata: {
      refundId: 'refund-002',
      flightNumber: '9J-302',
    },
  },
]

// Mock Invoices
export const MOCK_INVOICES: Invoice[] = [
  {
    id: 'inv-001',
    invoiceNumber: 'INV-2024-0001',
    airline: NIGERIAN_AIRLINES[0],
    amount: 12500000,
    period: { start: '2024-01-01', end: '2024-01-31' },
    status: 'paid',
    dueDate: '2024-02-15',
    paidAt: '2024-02-10',
    refundCount: 278,
    createdAt: '2024-02-01',
  },
  {
    id: 'inv-002',
    invoiceNumber: 'INV-2024-0002',
    airline: NIGERIAN_AIRLINES[1],
    amount: 8750000,
    period: { start: '2024-01-01', end: '2024-01-31' },
    status: 'overdue',
    dueDate: '2024-02-15',
    refundCount: 194,
    createdAt: '2024-02-01',
  },
  {
    id: 'inv-003',
    invoiceNumber: 'INV-2024-0003',
    airline: NIGERIAN_AIRLINES[2],
    amount: 5200000,
    period: { start: '2024-01-01', end: '2024-01-31' },
    status: 'sent',
    dueDate: '2024-02-28',
    refundCount: 115,
    createdAt: '2024-02-01',
  },
]

// Mock Fraud Alerts
export const MOCK_FRAUD_ALERTS: FraudAlert[] = [
  {
    id: 'alert-001',
    type: 'velocity',
    priority: 'high',
    status: 'open',
    description: 'Multiple refund requests from same IP within 1 hour',
    userId: 'user-suspicious-001',
    details: {
      requestCount: 5,
      timeWindow: '1 hour',
      ipAddress: '102.89.xx.xx',
    },
    createdAt: '2024-02-14T16:30:00',
  },
  {
    id: 'alert-002',
    type: 'mismatch',
    priority: 'medium',
    status: 'investigating',
    description: 'BVN name does not match ticket passenger name',
    refundId: 'refund-suspect-001',
    details: {
      bvnName: 'John Doe',
      ticketName: 'Jane Smith',
      similarity: 0.12,
    },
    createdAt: '2024-02-14T14:15:00',
  },
  {
    id: 'alert-003',
    type: 'repetition',
    priority: 'low',
    status: 'resolved',
    description: 'Same ticket number submitted multiple times',
    refundId: 'refund-dup-001',
    details: { ticketNumber: '0842401234567', attempts: 3 },
    createdAt: '2024-02-13T10:00:00',
    resolvedAt: '2024-02-13T11:30:00',
    resolvedBy: 'admin-001',
  },
]

// Mock Audit Logs
export const MOCK_AUDIT_LOGS: AuditLog[] = [
  {
    id: 'log-001',
    timestamp: '2024-02-14T16:45:00',
    userId: 'user-001',
    userName: 'Chioma Okonkwo',
    action: 'REFUND_INITIATED',
    resource: 'refund',
    resourceId: 'refund-001',
    details: 'Refund request initiated for ticket 0842401234567',
    ipAddress: '102.89.45.123',
    userAgent: 'Mozilla/5.0 (iPhone; CPU iPhone OS 17_0)',
  },
  {
    id: 'log-002',
    timestamp: '2024-02-14T16:46:00',
    userId: 'system',
    userName: 'System',
    action: 'KYC_VERIFIED',
    resource: 'refund',
    resourceId: 'refund-001',
    details: 'BVN verification successful via NIBSS',
    ipAddress: 'internal',
    userAgent: 'AeroZeep-System/1.0',
  },
  {
    id: 'log-003',
    timestamp: '2024-02-14T16:50:00',
    userId: 'system',
    userName: 'System',
    action: 'REFUND_COMPLETED',
    resource: 'refund',
    resourceId: 'refund-001',
    details: 'Store credit of ₦48,000 added to wallet',
    ipAddress: 'internal',
    userAgent: 'AeroZeep-System/1.0',
  },
]

// Mock Compliance Violations
export const MOCK_VIOLATIONS: ComplianceViolation[] = [
  {
    id: 'vio-001',
    airline: NIGERIAN_AIRLINES[1],
    type: 'late_refund',
    description:
      'Refund processed 72 hours after request (NCAA limit: 24 hours)',
    refundId: 'refund-late-001',
    severity: 'major',
    status: 'open',
    createdAt: '2024-02-14T10:00:00',
  },
  {
    id: 'vio-002',
    airline: NIGERIAN_AIRLINES[2],
    type: 'incorrect_amount',
    description: 'Refund amount ₦2,500 less than entitled amount',
    refundId: 'refund-amount-001',
    severity: 'minor',
    status: 'acknowledged',
    createdAt: '2024-02-13T15:30:00',
  },
]

// Nigerian Names for Mock Data
export const NIGERIAN_FIRST_NAMES = [
  'Chioma',
  'Emeka',
  'Ngozi',
  'Chukwudi',
  'Adaeze',
  'Obiora',
  'Chiamaka',
  'Ikenna',
  'Amara',
  'Chinedu',
  'Oluwaseun',
  'Adebayo',
  'Folake',
  'Olumide',
  'Yetunde',
  'Babatunde',
  'Aisha',
  'Ibrahim',
  'Fatima',
  'Musa',
  'Hauwa',
  'Abdullahi',
  'Zainab',
  'Usman',
]

export const NIGERIAN_LAST_NAMES = [
  'Okonkwo',
  'Eze',
  'Nwosu',
  'Okoro',
  'Okafor',
  'Nnadi',
  'Uzoma',
  'Chukwu',
  'Adeyemi',
  'Ogundimu',
  'Bakare',
  'Adeleke',
  'Oladipo',
  'Fashola',
  'Akinwale',
  'Oyelaran',
  'Mohammed',
  'Suleiman',
  'Bello',
  'Abubakar',
  'Yusuf',
  'Danladi',
  'Garba',
  'Aliyu',
]
